import React from 'react';
import styles from './image-fallback-small.scss';

export const ImageFallbackSmall: React.FunctionComponent = () => (
  <div className={styles.imageFallbackSmall} />
);
